import { combineReducers } from "redux";
import donate from "./donate";

export default combineReducers({
  donate: donate
});
